import { createRoot } from 'react-dom/client';

import { Stars } from '@ui/Stars';

export const renderProductRating = () => {
  const containers = document.querySelectorAll('.js-product-rating');

  if (containers.length) {
    Array.from(containers).forEach((container) => {
      const rating = Number(container.getAttribute('data-rating'));
      const ratingAmount = Number(container.getAttribute('data-rating-amount'));
      const productUrl = container.getAttribute('data-product-url');

      if (rating && ratingAmount) {
        const root = createRoot(container);
        if (productUrl) {
          root.render(
            <a
              className="b-product-rating b-product-rating_mt_8"
              href={`${productUrl}/reviews`}
            >
              <Stars
                value={rating}
                readOnly={true}
              />
              &nbsp;
              {`(${ratingAmount})`}
            </a>,
          );
        } else {
          root.render(
            <div className="b-product-rating b-product-rating_mt_4">
              <Stars
                value={rating}
                readOnly={true}
              />
              &nbsp;
              {`(${ratingAmount})`}
            </div>,
          );
        }
      }
    });
  }
};
